import { CheckboxProps } from '@mui/material'
import { useFormikContext } from 'formik'
import React, { ReactNode } from 'react'
import { BasicCheckbox } from '../BasicCheckbox'

interface Props<T> extends Omit<CheckboxProps, 'name' | 'label' | 'onChange'> {
  name: keyof T
  label: string | ReactNode
  onChange?(e: React.ChangeEvent<any>): void
}

export const FormikCheckbox = <T extends unknown>({ name, label, onChange, ...rest }: Props<T>) => {
  const { values, touched, errors, handleChange } = useFormikContext<T>()

  const isTouched = touched[name] as boolean
  const error = errors[name] as string | undefined

  return (
    <BasicCheckbox
      name={name as string}
      error={Boolean(isTouched && error)}
      helperText={isTouched && error}
      label={label}
      {...rest}
      onChange={onChange || handleChange(name)}
      value={values[name] as unknown as string | number | undefined}
    />
  )
}
